import type { BehaviorTrackingProps } from '../types/behavior-tracking-props.js';

/**
 * @internal
 */
export const behaviorTrackingPropKeys: ReadonlyArray<
  keyof BehaviorTrackingProps
> = [
  'data-dt-content',
  'data-dt-name',
  'data-dt-children-name',
  'data-dt-features',
  'data-dt-properties',
  'data-dt-mouse-over',
  'data-dt-value-content',
  'data-dt-children-value-content',
  'data-dt-ancestor',
];

/**
 * Extracts behavior tracking props (data-dt-*) from an object.
 * @internal
 */
export function extractBehaviorTrackingProps(
  props: object,
): BehaviorTrackingProps {
  const result: BehaviorTrackingProps = {};
  const record = props as Record<string, unknown>;
  for (const key of behaviorTrackingPropKeys) {
    const value = record[key];
    if (typeof value === 'string') {
      (result as Record<string, string>)[key] = value;
    }
  }
  return result;
}
